<script setup lang="ts">
import { snackbar, message, color } from '@/shared/composables/useNotifier'
import { computed } from 'vue'

const iconByType = computed(() => {
  switch (color.value) {
    case 'success':
      return 'mdi-check-circle'
    case 'error':
      return 'mdi-alert-circle'
    case 'warning':
      return 'mdi-alert'
    default:
      return 'mdi-information'
  }
})
</script>

<template>
  <v-app>
    <v-main>
      <RouterView />
    </v-main>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      timeout="3000"
      location="top"
      class="app-snackbar"
    >
      <v-icon class="me-2" size="20">{{ iconByType }}</v-icon>
      {{ message }}
    </v-snackbar>
  </v-app>
</template>

<style lang="scss">
.app-snackbar {
  .v-snackbar__content {
    color: white !important;
  }

  .v-icon {
    color: white !important;
  }
}
</style>
